export default "__VITE_ASSET__226ae222__"